import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
import { getSites } from './SiteSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  getOnsiteCountBySite: false,
  onsiteGateId: 0,
  onsiteSiteId: 0,
  currentPeopleOnsite: 'N/A',
  currentVehiclesOnsite: 'N/A',
}

export const getOnsiteCount = createAsyncThunk('onsite/getOnsiteCount', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { webToken } = state.auth
  const { getOnsiteCountBySite, onsiteSiteId, onsiteGateId } = state.onsite

  const id = getOnsiteCountBySite ? onsiteSiteId : onsiteGateId
  const url = getOnsiteCountBySite ? 'api/getonsitecount/site/' : 'api/getonsitecount/gate/'

  return await fetch( apiURL + url + id, {
      method: 'get',
      headers: { 'Accept': 'application/json', 'Authorization': webToken },
      credentials: 'include'
    })
    .then( res => res.json() )
    .then( data => data)
    .catch( error => {
      console.log(error)
      return {peopleCount: 'N/A', vehicleCount: 'N/A'}
    })
});

const onsiteSlice = createSlice({
  name: 'onsite',
  initialState,
  reducers: {
    setOnsiteState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOnsiteCount.fulfilled, (state, action) => {
        state.currentPeopleOnsite = action.payload.peopleCount
        state.currentVehiclesOnsite = action.payload.vehicleCount
      })
      .addCase(getSites.fulfilled, (state, action) => {
        state.onsiteSiteId = action.payload.onsiteSiteId
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setOnsiteState } = onsiteSlice.actions
export default onsiteSlice.reducer
